module.exports = __webpack_public_path__ + "static/media/pencil_green.9c7ca6db.svg";


//////////////////
// WEBPACK FOOTER
// ./src/res/img/pencil_green.svg
// module id = 134
// module chunks = 0